/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Column } from 'wrappers/FlexTable'
import Popover from 'components/generic/Popover'
import LoadingSpinner from 'components/LoadingSpinner'
import clsx from 'clsx'
import s from './Pets.module.css'
import petsAllowed from './petsAllowed.png'
import petsNotAllowed from './petsNotAllowed.png'
import petsUponApproval from './petsUponApproval.png'

const PETIMAGE_BY_NAME = {
  'all-pets-allowed': petsAllowed,
  'pets-upon-approval': petsUponApproval,
  'no-pets-allowed': petsNotAllowed,
}

const Pets = (props) => {
  const { selected, onChange, options, loading, customClassName } = props

  const targetRef = useRef(null)
  const [value, setValue] = useState(selected)

  useEffect(() => {
    setValue(selected)
  }, [selected])

  const className = !!selected && !loading ? 'btn-transparent-yellow' : 'btn-transparent-gray'

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.currentTarget.click()
    }
  }

  return (
    <Column className="searchbar-col">
      <Popover type="click" targetRef={targetRef}>
        <div className="pets-pop">
          <Column
            style={{
              width: '325px',
              background: '#000',
              border: '1px solid #404040',
              borderRadius: '21px',
            }}
            className="beds"
          >
            <Column className="rounded-row">
              {options.length && !loading ? (
                <>
                  <div className={s.options}>
                    {options
                      ?.filter((optionItem) => optionItem.value !== 'any')
                      ?.map((option) => (
                        <div
                          role="button"
                          tabIndex={0}
                          key={`bed-${option.value}`}
                          className={clsx(s.option, value === option.value && s.selectedOption)}
                          onClick={() => setValue(option.value)}
                        >
                          <div className={s.optionImageWrapper}>
                            <img src={PETIMAGE_BY_NAME?.[option.value]} alt={option.name} className={s.optionImage} />
                          </div>
                          {option.name}
                        </div>
                      ))}
                  </div>

                  <div className={s.controls}>
                    <button
                      type="button"
                      className={s.clear}
                      onKeyDown={handleKeyPress}
                      onClick={() => {
                        setValue('')
                        onChange('')
                        targetRef.current.click()
                      }}
                    >
                      Clear
                    </button>
                    <div className={s.delimiter} />
                    <button
                      type="button"
                      className={s.apply}
                      onKeyDown={handleKeyPress}
                      onClick={() => {
                        onChange(value)
                        targetRef.current.click()
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </>
              ) : (
                <LoadingSpinner />
              )}
            </Column>
          </Column>
        </div>
      </Popover>
      <input
        ref={targetRef}
        name="pets"
        type="button"
        className={clsx(`button btn-rounded ${className} btn-search-bar-size`, customClassName)}
        value="Pets"
      />
    </Column>
  )
}

Pets.defaultProps = {
  selected: '',
  options: [],
  onChange: () => {},
  loading: false,
}

Pets.propTypes = {
  selected: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  loading: PropTypes.bool,
}

export default Pets
